/** Routes where the notes drawer may stay open while navigating. */
export function isNotesCapableRoute(pathname: string, search = ''): boolean {
  if (pathname === '/tenant/tenants') {
    return new URLSearchParams(search).has('propertyId')
  }
  if (/^\/tenant\/tenants\/[^/]+$/.test(pathname) && !pathname.endsWith('/edit')) {
    return true
  }
  if (/^\/program\/programs\/[^/]+$/.test(pathname) && !pathname.endsWith('/reconciliation')) {
    return true
  }
  if (/^\/tenant\/onboarding\/[^/]+$/.test(pathname)) {
    return pathname.startsWith('/tenant/onboarding/TESA') === false
      && pathname.startsWith('/tenant/onboarding/TESAsupplement') === false
  }
  if (/^\/admin\/tariffs\/(?!rate-validation$|acc-rates$)[^/]+$/.test(pathname)) {
    return true
  }
  return false
}
